var hcMain = new Swiper ('.hc-main-slider', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  slidesPerScroll: 1,
  speed: 600,
  centeredSlides: true,
  autoHeight: true,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
});

var hcMainSlides = [];
$(".hc-main-slider .swiper-slide").each(function(){
  hcMainSlides.push($(this));
});

var hcColors = [];
$(".hc-colors-swiper .swiper-slide").each(function(){
  hcColors.push($(this));
});

var hcColorsMobile = [];
$(".hc-color-images-mobile .swiper-slide").each(function(){
  hcColorsMobile.push($(this));
});

var hcPads = [];
$(".hc-upsell-slideshow-pads .swiper-slide").each(function(){
  hcPads.push($(this));
});

var hcPadsMobile = [];
$(".hc-pads-slideshow .swiper-slide").each(function(){
  hcPadsMobile.push($(this));
});

var hcTarps = [];
$(".hc-upsell-slideshow-tarps .swiper-slide").each(function(){
  hcTarps.push($(this));
});

var hcTarpMobile = [];
$(".hc-tarps-slideshow .swiper-slide").each(function(){
  hcTarpMobile.push($(this));
});

var hcColorsSwM, hcPadsSwM, hcTarpsSwM, hcColorsSw, hcPadsSw, hcTarpsSw;

if(window.innerWidth <= 1024) {
  hcColorsSwM = new Swiper ('.hc-color-images-mobile', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    slidesPerScroll: 1,
    speed: 600,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    effect: 'fade',
      fadeEffect: {
        crossFade: true
    }
  });
  
  hcPadsSwM = new Swiper ('.hc-pads-slideshow', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    slidesPerScroll: 1,
    speed: 600,
    observer: true, 
    observeParents: true,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    effect: 'fade',
      fadeEffect: {
        crossFade: true
    }
  });
    
  hcTarpsSwM = new Swiper ('.hc-tarps-slideshow', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    slidesPerScroll: 1,
    speed: 600,
    centeredSlides: true,
    observer: true, 
    observeParents: true,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    effect: 'fade',
      fadeEffect: {
        crossFade: true
    }
  });
}else{
  hcColorsSw = new Swiper ('.hc-colors-swiper', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerScroll: 1,
      speed: 600,
      observer: true, 
      observeParents: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
    });
  
    hcPadsSw = new Swiper ('.hc-upsell-slideshow-pads', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerScroll: 1,
      speed: 600,
      centeredSlides: true,
      observer: true, 
      observeParents: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
          crossFade: true
      },
    });
      
    hcTarpsSw = new Swiper ('.hc-upsell-slideshow-tarps', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerScroll: 1,
      speed: 600,
      centeredSlides: true,
      observer: true, 
      observeParents: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
    });
}

$('.hc-compare-slider').slick({
  dots: true,
  arrows: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true
});